import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISetting } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

@Injectable({
    providedIn: 'root',
})
export class SettingsService extends ODataService<ISetting, string> {
    protected _endpoint = '/odata/Settings/UiPath.Server.Configuration.OData.GetWebSettings';

    constructor(
        http: HttpClient,
        protected _http: HttpClient,
    ) {
        super(http, MapperService.settingMap);
    }

    public setLanguage(languageCode: string) {
        const payload = JSON.stringify({ culture: languageCode });
        return this._http.post(`/odata/Users/UiPath.Server.Configuration.OData.ChangeCulture()`, payload);
    }
}
